/** ******************************************************************
 *
 *  PROPRIETARY and CONFIDENTIAL
 *
 *  This file is licensed from, and is a trade secret of:
 *
 *                   AvePoint, Inc.
 *                   525 Washington Blvd, Suite 1400
 *                   Jersey City, NJ 07310
 *                   United States of America
 *                   Telephone: +1-201-793-1111
 *                   WWW: www.avepoint.com
 *
 *  Refer to your License Agreement for restrictions on use,
 *  duplication, or disclosure.
 *
 *  RESTRICTED RIGHTS LEGEND
 *
 *  Use, duplication, or disclosure by the Government is
 *  subject to restrictions as set forth in subdivision
 *  (c)(1)(ii) of the Rights in Technical Data and Computer
 *  Software clause at DFARS 252.227-7013 (Oct. 1988) and
 *  FAR 52.227-19 (C) (June 1987).
 *
 *  Copyright © 2016-2024 AvePoint® Inc. All Rights Reserved.
 *
 *  Unpublished - All rights reserved under the copyright laws of the United States.
 */
/*Covered by AvePoint copyright and license agreement*/
var Partner;
(function (Partner) {
    var partnerSignUpUrl = "";
    var errorMessage = "";
    var loadingIndicator;
    var OEMLoginPage = /** @class */ (function () {
        function OEMLoginPage(signUpUrl) {
            partnerSignUpUrl = signUpUrl;
            this.init();
        }
        OEMLoginPage.prototype.init = function () {
            initEventHandler();
            loadingIndicator = new Partner.CustomerLoading(document.body);
            loadingIndicator.hide();
        };
        return OEMLoginPage;
    }());
    Partner.OEMLoginPage = OEMLoginPage;
    function initEventHandler() {
        var _a, _b, _c, _d, _e, _f;
        (_a = document.getElementById("account_login_username")) === null || _a === void 0 ? void 0 : _a.addEventListener("focus", function () {
            var accountLoginErrorMessage = document.getElementById("account_login_errormessage");
            if (accountLoginErrorMessage) {
                accountLoginErrorMessage.style.display = "none";
            }
            var accountLoginTitle = document.querySelector(".account_login_login_title");
            if (accountLoginTitle) {
                accountLoginTitle.style.display = "block";
            }
        });
        (_b = document.getElementById("account_login_username")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function () {
            var accountLoginErrorMessage = document.getElementById("account_login_errormessage");
            if (accountLoginErrorMessage) {
                accountLoginErrorMessage.style.display = "none";
            }
            var accountLoginTitle = document.querySelector(".account_login_login_title");
            if (accountLoginTitle) {
                accountLoginTitle.style.display = "block";
            }
        });
        document.querySelectorAll(".login-button, .elements-login-button").forEach(function (element) {
            element === null || element === void 0 ? void 0 : element.addEventListener("click", function () {
                submitForm();
            });
        });
        (_c = document.getElementById("o365_login")) === null || _c === void 0 ? void 0 : _c.addEventListener("click", function () {
            var search = window.location.search;
            window.location.href = search ? "/customer/PartnerO365Login".concat(search) : "/customer/PartnerO365Login";
        });
        (_d = document.getElementById("gov_login")) === null || _d === void 0 ? void 0 : _d.addEventListener("click", function () {
            var search = window.location.search;
            window.location.href = search ? "/customer/PartnerO365LoginGOV".concat(search) : "/customer/PartnerO365LoginGOV";
        });
        var descriptionArrowElement = (_e = document.getElementById("account_login_errormessage")) === null || _e === void 0 ? void 0 : _e.querySelector(".description_arrow");
        if (descriptionArrowElement) {
            descriptionArrowElement === null || descriptionArrowElement === void 0 ? void 0 : descriptionArrowElement.addEventListener("click", function (e) {
                var current = e.target;
                current.style.display = "none";
                current.previousElementSibling.style.display = "none";
                current.previousElementSibling.previousElementSibling.style.height = "auto";
            });
        }
        //$(".not-have-account-container,.elements-not-have-account-container").bind(
        //  "click",
        //  function () {
        //    window.location.href = partnerSignUpUrl;
        //  }
        //);
        document.querySelectorAll(".forgot-container, .elements-forgot-container").forEach(function (element) {
            element === null || element === void 0 ? void 0 : element.addEventListener("click", function () {
                window.location.href = "/forgetpassword/index";
            });
        });
        document.querySelectorAll(".login-form-content, .elements-signin-container").forEach(function (element) {
            element === null || element === void 0 ? void 0 : element.addEventListener("keydown", function (event) {
                if (event.keyCode == 13) {
                    submitForm();
                }
            });
        });
        //$('.ibm-cookie-link').bind("click", function () {
        //window.open('https://www.ibm.com/privacy')
        //})
        (_f = document.querySelector(".fix-fottor-cookie--right")) === null || _f === void 0 ? void 0 : _f.addEventListener("click", function () {
            //document.cookie = "cookieName= true; expires=Tue, 19 Jan 2038 04:14:07 GMT";
            var daysToExpire = new Date(2147483647 * 1000).toUTCString();
            document.cookie = "IBMLoginCookie=true;expires=".concat(daysToExpire);
            var footerCookie = document.querySelector(".fix-fotter-cookie");
            if (footerCookie) {
                footerCookie.style.display = "none";
            }
        });
        function getCookie(cname) {
            var name = "".concat(cname, "=");
            var ca = document.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i].trim();
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
        if (!getCookie("IBMLoginCookie")) {
            if (document.querySelector(".fix-fotter-cookie")) {
                document.querySelector(".fix-fotter-cookie").style.display = "block";
            }
        }
    }
    function getParameterByName(name) {
        var url = window.location.href;
        var params = url.slice(url.indexOf("?") + 1).split("&");
        for (var i = 0; i < params.length; i++) {
            var param = params[i].split("=");
            if (param[0] === name) {
                return decodeURIComponent(param[1].replace(/\+/g, " "));
            }
        }
        return null;
    }
    function submitForm() {
        var _a, _b;
        if (validateElement()) {
            loadingIndicator.show();
            var target_1 = "";
            if (window.location.search) {
                target_1 = getParameterByName("target");
            }
            Partner.customerWebapi
                .oemLoginApi({
                username: (_a = document.querySelector("#account_login_username")) === null || _a === void 0 ? void 0 : _a.value,
                password: (_b = document.querySelector("#account_login_password")) === null || _b === void 0 ? void 0 : _b.value,
                forwardTo: target_1,
            })
                .then(function (result) {
                if (result.type == "faield") {
                    loadingIndicator.hide();
                    errorMessage = result.msg;
                    showErrorMessage(true);
                    document.querySelectorAll("input").forEach(function (input) { return input === null || input === void 0 ? void 0 : input.removeAttribute("readonly"); });
                }
                else if (result.type == "mfa") {
                    // I have no method to replace HTML content into React
                    // I have to create a dynamic form to post and redirect to a MVC controller to create HTML content from server.
                    var mfaForm = document.createElement("form");
                    mfaForm.method = "POST";
                    mfaForm.action = "/Customer/PartnerLoginWithMFA";
                    var userNameInput = document.createElement("input");
                    userNameInput.name = "username";
                    userNameInput.value = document.querySelector("#account_login_username").value;
                    var passwordInput = document.createElement("input");
                    passwordInput.name = "password";
                    passwordInput.value = document.querySelector("#account_login_password").value;
                    var forwardInput = document.createElement("input");
                    forwardInput.name = "forwardTo";
                    forwardInput.value = target_1;
                    mfaForm.appendChild(userNameInput);
                    mfaForm.appendChild(passwordInput);
                    mfaForm.appendChild(forwardInput);
                    document.body.appendChild(mfaForm);
                    mfaForm.submit();
                }
                else {
                    window.location.href = result.msg;
                }
            })
                .catch(function (error) {
                loadingIndicator.hide();
                document.body.classList.remove("loading");
                if (document.querySelector(".account_login_button_loading")) {
                    document.querySelector(".account_login_button_loading").style.display = "none";
                }
                document.querySelectorAll("input").forEach(function (input) { return input === null || input === void 0 ? void 0 : input.removeAttribute("readonly"); });
                if (document.querySelector(".account_login_input_container")) {
                    document.querySelector(".account_login_input_container").classList.remove("aria-disabled");
                }
                document.body.innerHTML = error.message;
            });
        }
    }
    function validateElement() {
        var _a, _b;
        if (((_a = document.querySelector("#account_login_username")) === null || _a === void 0 ? void 0 : _a.value.trim()) === "") {
            Partner.customerValidateInput("account_login_username", Partner.i18n.get("Partner_Gui_IBM_Sign_UserName_Required_Error", "Enter your E-mail Address to proceed."));
            return false;
        }
        else {
            Partner.customerValidateInput("account_login_username", "");
        }
        if (((_b = document.querySelector("#account_login_password")) === null || _b === void 0 ? void 0 : _b.value.trim()) === "") {
            Partner.customerValidateInput("account_login_password", Partner.i18n.get("Partner_Gui_IBM_Sign_Password_Required", "Please enter the password."));
            return false;
        }
        else {
            Partner.customerValidateInput("account_login_password", "");
        }
        return true;
    }
    function showErrorMessage(initLoading) {
        var _a;
        if (errorMessage && errorMessage.length > 0) {
            if (document.querySelector(".account_login_login_title")) {
                document.querySelector(".account_login_login_title").style.display = "none";
            }
            var accountLoginErrorMessageContainer = document.querySelector("#account_login_errormessage");
            var accountLoginErrorMessage = document.querySelector("#account_login_errormessage .message > span");
            if (accountLoginErrorMessageContainer && accountLoginErrorMessage) {
                accountLoginErrorMessage.textContent = errorMessage;
                accountLoginErrorMessageContainer.setAttribute("data-msgtype", "error");
                accountLoginErrorMessageContainer.style.display = "block";
            }
            var messageElement_1 = document.querySelector("#account_login_errormessage .message");
            var messageSpan_1 = document.querySelector("#account_login_errormessage .message > span");
            var messageEllipsis = document.querySelector("#account_login_errormessage .message + .ellipsis");
            var messageDescriptionArrow = document.querySelector("#account_login_errormessage .message .description_arrow");
            if ((messageElement_1 === null || messageElement_1 === void 0 ? void 0 : messageElement_1.offsetHeight) < (messageSpan_1 === null || messageSpan_1 === void 0 ? void 0 : messageSpan_1.offsetHeight)) {
                if (messageEllipsis) {
                    messageEllipsis.style.display = "block";
                }
                if (messageDescriptionArrow) {
                    messageDescriptionArrow.style.display = "block";
                }
            }
            else {
                if (messageEllipsis) {
                    messageEllipsis.style.display = "none";
                }
                if (messageDescriptionArrow) {
                    messageDescriptionArrow.style.display = "none";
                }
            }
            if (errorMessage.indexOf("account_login_resend_link") > 0) {
                (_a = document.querySelector("#account_login_resend_link")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
                    var _a;
                    loadingIndicator.show();
                    window
                        .fetch((_a = document.querySelector("#account_login_resend_link")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-href"), { method: "POST" })
                        .then(function (response) { return response.json(); })
                        .then(function (data) {
                        var _a;
                        document.body.classList.remove("loading");
                        if (data === "resendsuccess") {
                            var msg = "The e-mail will be sent soon. Please check your e-mail to activate your account and try to sign in again.";
                            var accountLoginMessage = document.querySelector("#account_login_errormessage .message > span");
                            if (accountLoginMessage) {
                                accountLoginMessage.textContent = msg;
                            }
                            (_a = document.querySelector("#account_login_errormessage")) === null || _a === void 0 ? void 0 : _a.setAttribute("data-msgtype", "success");
                            var ellipsis = document.querySelector("#account_login_errormessage .message + .ellipsis");
                            var arrow = document.querySelector("#account_login_errormessage .message .description_arrow");
                            if (ellipsis && arrow) {
                                if ((messageElement_1 === null || messageElement_1 === void 0 ? void 0 : messageElement_1.offsetHeight) < (messageSpan_1 === null || messageSpan_1 === void 0 ? void 0 : messageSpan_1.offsetHeight)) {
                                    ellipsis.style.display = "block";
                                    arrow.style.display = "block";
                                }
                                else {
                                    ellipsis.style.display = "none";
                                    arrow.style.display = "none";
                                }
                            }
                        }
                    })
                        .catch(function (error) {
                        document.body.classList.remove("loading");
                        document.body.innerHTML = error.message;
                    });
                });
            }
        }
    }
})(Partner || (Partner = {}));
